export { TypingAnimationModule } from './typing-animation.module';
export { TypingAnimationDirective } from './typing-animation.directive';

//# sourceMappingURL=index.js.map